import React from 'react'
import '../../../styles/onboardingStep1.css';
import { Button } from '@material-ui/core';
import { inject, observer } from 'mobx-react';
import { Redirect, withRouter } from 'react-router-dom';
import { createBrowserHistory as createHistory } from 'history'
import Modal from "react-bulma-components/lib/components/modal";
const history = createHistory()
const imagesPath = {
    unchecked: require('../../../assets/unchecked_interest.png'),
    checked:require('../../../assets/checked_interest.png')
}
@inject('userStore', 'navigatorStore', 'authStore')
@withRouter
@observer
export default class onboardingStep_1 extends React.Component {
    constructor() {
        super();

        this.state = {
            output: {
                interests: ""
            },
            buy: false,
            sell: false,
            browse: false,
            onboardingInProcess: true
        }
    }

    componentWillUnmount() {
        this.props.authStore.resetRegisterSuccess;

    }

    componentDidMount() {
        if (window.localStorage.hasOwnProperty("userData")) {
            this.props.userStore.pulluser()
                .then((response) => {
                    // console.log(response);
                    if (response.data[0].interests != null) {
                        this.setState({
                            userInterests: response.data[0].interests,
                            buy: (response.data[0].interests.includes("Buy") ? true : false),
                            sell: (response.data[0].interests.includes("Sell") ? true : false),
                            browse: (response.data[0].interests.includes("Browse") ? true : false),
                        })
                    }
                })
        }
        if (window.location.href.includes("edit-profile") && this.props.navigatorStore.OB1Open) {
            this.backListener = history.listen(location => {
                // if (location.hash === "#/") {
                // Do your stuff
                // console.log("popping", location, window.location.href)
                this.props.navigatorStore.closeOB1Modal()
                this.props.history.replace('/edit-profile')

                // }
            });
        } else if ((window.location.href.includes("profile/details") || window.location.href.includes("product/details")) && this.props.navigatorStore.OB1Open) {
            // console.log("coming here")
            this.backListener = history.listen(location => {
                // if (location.hash === "#/") {
                window.localStorage.clear()
                window.location.reload()
            });
        }
    }
    wantsToBuy() {
        this.setState({
            buy: !this.state.buy,
        }, function () {
            // console.log(this.state.buy)

        })
    }

    wantsToSell() {
        this.setState({
            sell: !this.state.sell,
        }, function () {
            // console.log(this.state.sell)

        })
    }
    prevStep() {

    }
    wantsToBrowse() {
        this.setState({
            browse: !this.state.browse,
        }, function () {
            // console.log(this.state.browse)

        })
    }

    getImageNameBuy = () => this.state.buy ? 'checked' : 'unchecked'
    getImageNameSell = () => this.state.sell ? 'checked' : 'unchecked'
    getImageNameBrowse = () => this.state.browse ? 'checked' : 'unchecked'

    nextStep(item) {
        // if (!this.state.buy && !this.state.sell && !this.state.browse) {
        //     this.props.navigatorStore.openErrorModal("please choose your interest");
        //     return;
        // }

        let body = ""
        if (item === "next") {
            if (this.state.buy) {
                body = body.concat("Buy, ")
            }
            if (this.state.sell) {
                body = body.concat("Sell, ")
            }
            if (this.state.browse) {
                body = body.concat("Browse, ")
            }

            if (this.props.navigatorStore.editMode) {
                this.props.navigatorStore.closeOB1Modal()
                this.props.navigatorStore.displayEditedInterests(body.substring(0, body.lastIndexOf(",")))
                this.props.history.replace('/edit-profile')
            } else {
                this.props.userStore.requestToEditUser(null, { interests: body.substring(0, body.lastIndexOf(",")) })
                    .then((response) => {
                        // console.log(response)
                        this.props.navigatorStore.openOB2Modal()
                        this.props.navigatorStore.closeOB1Modal()
                    })
            }
            // console.log("[look body ]", body)
        }
        else {
            // if (this.props.authStore.RegisterSuccess) {
            //     localStorage.clear();
            //     window.location.reload()
            // }
            this.props.navigatorStore.closeOB1Modal()
            // if (this.props.navigatorStore.editMode) {
            //     // console.log("closing a midal")
                this.props.navigatorStore.openOB2Modal()
            // }
        }
    }
    close() {
        this.props.navigatorStore.closeOB1Modal()
    }
    componentWillReceiveProps() {
        if (window.localStorage.hasOwnProperty("userData") && (this.props.authStore.loginDone || this.props.authStore.registerSuccess)) {
            this.props.userStore.pulluser()
                .then((response) => {
                    // console.log(response);
                    if (response.data[0].interests != null) {
                        this.setState({
                            userInterests: response.data[0].interests,
                            buy: (response.data[0].interests.includes("Buy") ? true : false),
                            sell: (response.data[0].interests.includes("Sell") ? true : false),
                            browse: (response.data[0].interests.includes("Browse") ? true : false),
                        })
                    }
                })
        }
    }

    render() {

        const imageNameBuy = this.getImageNameBuy();
        const imageNameSell = this.getImageNameSell();
        const imageNameBrowse = this.getImageNameBrowse();


        if (this.state.navToHome) {
            this.props.authStore.logout()
            return (
                <Redirect push to="/"></Redirect>
            )
        }
        if (this.state.onboardingInProcess)
            return (
                <Modal show={this.props.navigatorStore.OB1Open}>
                    <Modal.Content >
                        <div className="heading-welcome">
                            WELCOME
                            <img 
                            style={{display : (window.location.href.includes("edit-profile")) ? "" : "none"}}
                            onClick={this.close.bind(this)} className="cross-icon-for-masterpieces-modal" src={require('../../../assets/cross_icon_for_close.png')}></img>
                    <hr className="line-category-name margin-auto"></hr>
                        </div>
                        <div className="container onboarding-container" style={{ padding: "0px", width: "91%" }}>
                            <div className="content">
                                <div className="heading-text">
                                    {/* <div className="onboarding-question">
                                        What are your interests?
                            </div> */}
                                    <div style={{ textAlign: "left" }} className="onboarding-question">What are your interests?
                        </div>
                                    <div className="onboarding-step-number">
                                        Step 1 of 3
                            </div>
                                   
                                </div>

                                <div className="buy-art">

                                    <div className="step-block">
                                        <div className="para-heading" >
                                            Buy Art</div>
                                        <div className="para-content"> I want to buy art on the masterpieces platform.</div>
                                    </div>
                                    <div>
                                        <a onClick={this.wantsToBuy.bind(this)}>

                                            <img alt="" className="image-like" src={imagesPath[imageNameBuy]} onClick={this.wantsToBuy.bind(this)}></img>
                                        </a>
                                    </div>
                                </div>

                                <div className="sell-art">

                                    <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
                                        <h className="para-heading" >
                                            Sell Art</h>
                                        <p className="para-content"> I want to sell art on the masterpieces platform.</p>
                                    </div>
                                    <div>
                                        <a onClick={this.wantsToSell.bind(this)}>
                                            <img alt="" className="image-like" src={imagesPath[imageNameSell]}></img>
                                        </a>
                                    </div>
                                </div>

                                <div className="browse-art">

                                    <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
                                        <h className="para-heading" >
                                            Browse Art</h>
                                        <p className="para-content"> I want to browse art on the masterpieces platform.</p>
                                    </div>
                                    <div>
                                        <a onClick={this.wantsToBrowse.bind(this)}>
                                            <img alt="" className="image-like" src={imagesPath[imageNameBrowse]}></img>
                                        </a>
                                    </div>
                                </div>
                                <div style={{ display: "flex", flex: 1, flexDirection: "column" }}>

                                    {/* <InterestFields state={this.state} imagesPath={imagesPath} Interests={Interests} onClicking={this.handleClickingInterest.bind(this)} /> */}
                                    <div className="row margin-25 mt-25">

                                        <div className="col-md-6 col-sm-6 col-xs-12 width-50 pull-left mb-30" style={{ marginBottom: "30px", display: (this.props.navigatorStore.editMode) ? "none" : "" }}>
                                            <Button className="masterpieces-secondary-buttons button-prev ml-0 step2-button-secondary" onClick={() => this.nextStep("skip")}>
                                                SKIP
                                    </Button>
                                        </div>

                                        <div className="col-md-6 col-sm-6 col-xs-12 width-50 pull-right mb-30" style={{ marginBottom: "30px" }}>
                                            <Button className="masterpieces-primary-buttons step2-button-primary"
                                                onClick={() => this.nextStep("next")}>{(this.props.navigatorStore.editMode) ? "DONE" : "NEXT"}
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal.Content>
                </Modal>
                // sample
            )
        if (!this.state.onboardingInProcess) {
            if (window.localStorage.hasOwnProperty("userData")) {

                this.props.authStore.resetOnboardingStatuses("onboardingOneIncomplete")
                return (
                    <Redirect push to='/onboardingtwo' />
                )
            }
            else return (

                <Redirect push to='/' />
            )

        }
    }

}


// WEBPACK FOOTER //
// ./src/components/Home/onboarding/onboarding1-modal.js